import React, { useEffect, useState, useRef } from 'react';
import LinearProgress from "../loading/LinearProgress";
import CircleIconButton from "../buttons/CircleIconButton";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import messages from "res/messages/farsi";
import StandardButtonFit from "../buttons/StandardButtonFit";
import 'leaflet-search/dist/leaflet-search.min.css';
import 'leaflet-search';
import ICLocation from 'res/images/location.png';
import ICSearch from "res/images/magnifire.png";
import ICClear from '@material-ui/icons/Clear';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder';
import { callExternalApi } from "../../connection/ClientApi";

function LeafletMapComponent(props) {
    const [key, setKey] = useState(1);
    const [map, setMap] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [progressShowStatus, setProgressShowStatus] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [predictions, setPredictions] = useState([]);
    const [mapContainerId] = useState(`map-${Math.random()}`);

    const [searchMarkers, setSearchMarkers] = useState([]);
    const inputRef = useRef(null);
    const showLocationRef = useRef(null);
    let mapMarkers = [];

    const clearMapMarkers = () => {

        if (map) {
            for (let mapMarker of mapMarkers) {
                map.removeLayer(mapMarker);
            }
            mapMarkers = [];
        }
    };

    const onSearch = (e) => {
        const value = e.target.value;

        setSearchValue(value);

        if (value) {
            const url = `https://nominatim.openstreetmap.org/search?format=json&q=${value}&addressdetails=1&limit=5&accept-language=fa`;
            let headers = { 'Api-Key': 'service.c7r1G613AAPfQuHIi4WZ1WegO74q83oVUmTXe6qM' };

            callExternalApi(url, undefined, 'GET', headers,
                (data) => {
                    setPredictions(data ? data : []);
                    setProgressShowStatus(false);
                }, () => { },
                () => { setProgressShowStatus(true); },
                () => { }
            );
        } else {
            setPredictions([]);
        }
    };

    const clearSearchMarkers = () => {
        if (map && searchMarkers.length > 0) {
            for (let marker of searchMarkers) {
                map.removeLayer(marker);
            }
            setSearchMarkers([]);
        }
    };

    const onMapInit = () => {
        const myMap = L.map(mapContainerId, {
            center: getCenter(),
            zoom: props.zoom || 15,
            doubleClickZoom: !props.isStatic,
            closePopupOnClick: !props.isStatic,
            dragging: !props.isStatic,
            zoomSnap: !props.isStatic,
            zoomDelta: !props.isStatic,
            trackResize: !props.isStatic,
            touchZoom: !props.isStatic,
            zoomControl: !props.isStatic,
            scrollWheelZoom: !props.isStatic,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; ØµØ±ÙÙ ÙØ§Ø±Ú©Øª'
        }).addTo(myMap);

        clearMapMarkers();

        if (props.markers && props.markers.length > 0) {
            for (let pMarker of props.markers) {
                let marker = L.marker(getPosition(pMarker), getIcon(pMarker));
                if (pMarker.popupTitle) {
                    marker.bindPopup(pMarker.popupTitle);
                }
                marker.addTo(myMap);
                mapMarkers.push(marker);

            }

            if (props.markers.length > 1) {
                let boundsCoordinate = [];
                for (let pMarker of props.markers) {
                    boundsCoordinate.push(getPosition(pMarker));
                }
                myMap.fitBounds(new L.LatLngBounds(boundsCoordinate), { padding: [50, 50] });
            }
        }

        if (props.showMyLocation) {
            L.circle(getCurrentLocation(), getCircleStyle()).addTo(myMap);
        }

        if (props.onClick) {
            myMap.on('click', function (e) {
                clearSearchMarkers();
                clearMapMarkers();
                if ((!inputRef.current || !inputRef.current.contains(e.originalEvent.target)) && (!showLocationRef.current || !showLocationRef.current.contains(e.originalEvent.target))) {
                    for (let mapMarker of mapMarkers) {
                        myMap.removeLayer(mapMarker);
                    }
                    let clickedMarker = {
                        latitude: e.latlng.lat,
                        longitude: e.latlng.lng,
                        icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/home.png"
                    };
                    let marker = L.marker(getPosition(clickedMarker), getIcon(clickedMarker));
                    marker.addTo(myMap);
                    mapMarkers.push(marker);
                    props.onClick(e);
                }
            });
        }
        setMap(myMap);
    };


    function getMapControls() {
        return (
            <>
                {props.enableSearch && (
                    <div style={{ position: "absolute", top: "4%", right: "1%" }} className="fullWidth highZIndex_0"  >
                        <center className="wInLP50_wInT50_wInT70_wInMS70">
                            <div className="searchInputBoxWhite" style={{padding:'0.2rem'}}>
                                <img className
                                         ="marginSmall" style={{ height: "1.5em" }} src={ICSearch} alt="" />
                                <Autocomplete
                                    key={key}
                                    freeSolo
                                    disableClearable
                                    style={{ width: "100%", fontSize: "10px" }}
                                    options={predictions}
                                    getOptionLabel={(option) => option.display_name}
                                    onChange={(e, value) => {
                                        if (value && value.lat && value.lon) {
                                            const location = { lat: parseFloat(value.lat), lon: parseFloat(value.lon) };
                                            map.setView([location.lat, location.lon], 15);
                                            clearSearchMarkers(); // Ø­Ø°Ù ÙØ§Ø±Ú©Ø±ÙØ§Û Ø¬Ø³ØªØ¬Ù
                                            const marker = L.marker([location.lat, location.lon], {
                                                icon: L.icon({
                                                    iconUrl: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/Files/EndPoint.png",
                                                    iconAnchor: [10, 50],
                                                    popupAnchor: [5, -50]
                                                })
                                            }).addTo(map);
                                            marker.bindPopup(value.display_name).openPopup();
                                            setSearchMarkers([marker]); // Ø°Ø®ÛØ±Ù ÙØ§Ø±Ú©Ø± Ø¬Ø¯ÛØ¯ Ø¯Ø± ÙØ¶Ø¹ÛØª ÙØ­ÙÛ
                                        }
                                    }}
                                    renderInput={(param) => (
                                        <TextField
                                            {...param}
                                            onChange={onSearch}
                                            placeholder={messages.searchPlace}
                                            className={"transparent center largeText defaultFont fullHeight"}
                                            InputProps={{
                                                ...param.InputProps,
                                                disableUnderline: true,
                                                endAdornment: searchValue !== "" && (
                                                    <StandardButtonFit
                                                        icon={<ICClear className="grayColor marginLeftSmall" />}
                                                        onClick={() => {
                                                            searchMarkers.forEach(marker => map.removeLayer(marker));
                                                            if (props.onClearSearch) {
                                                                props.onCenterChange();
                                                            }
                                                            setPredictions([]);
                                                            setSearchValue('');
                                                            setKey(Math.random() * 100);
                                                        }}
                                                    />
                                                )
                                            }}
                                            ref={inputRef}
                                        />
                                    )}
                                />
                            </div>
                            {progressShowStatus && <LinearProgress />}
                        </center>
                    </div>
                )}
                {props.isEnableCurrentLocation && (
                    <div style={{ position: "absolute", left: "1%", bottom: "7%" }} className="highZIndex_0" ref={showLocationRef}>
                        <CircleIconButton
                            hover={"var(--gray_1)"}
                            background={"var(--white)"}
                            width={"1.8em"} height={"1.8em"}
                            icon={<img className="smallIcon" src={ICLocation} alt="" />}
                            onClick={() => {
                                map.setView(getCurrentLocation(), map.getZoom());
                            }}
                        />
                    </div>
                )}
            </>
        );
    }

    function getIcon(marker) {
        return marker.icon ? {
            icon: L.icon({
                iconUrl: marker.icon,
                iconAnchor: [25, 50],
                popupAnchor: [5, -50]
            })
        } :
         {}
    }

        function getCircleStyle() {
            return {
                color: 'var(--blue_4)',
                fillColor: 'var(--blue_6)',
                fillOpacity: 0.5,
                radius: 200
            };
        }

        function getPosition(marker) {
            if (!marker || isNaN(marker.latitude) || isNaN(marker.longitude)) {
                return [0, 0];
            }
            return [parseFloat(marker.latitude), parseFloat(marker.longitude)];
        }

        function getCenter() {
            if (props.center) {
                return [props.center.latitude, props.center.longitude];
            }
            return [35.699739, 51.348097];
        }

        function getCurrentLocation() {
            return [
                currentLocation ? currentLocation.latitude : 35.699739,
                currentLocation ? currentLocation.longitude : 51.348097
            ];
        }

        useEffect(() => {
            if (!props.isFirstLode && !map && !props.isStatic && props.isEnableCurrentLocation) {
                navigator.geolocation.watchPosition(position => {
                    setCurrentLocation(position.coords);
                });
                onMapInit();
            }
        }, [map]);

        useEffect(() => {
            if (props.isFirstLode){
                onMapInit();
            }
        }, []);

        return (
            <div id={mapContainerId} style={{ position: "relative", width: "100%", height: "100%" }}>
                {!props.isStatic && getMapControls()}
            </div>
        );
    }

    export default LeafletMapComponent;
